module.exports = __webpack_public_path__ + "img/login-v2.aa5e43c0.svg";